// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCar } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const Car: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faCar} />
//     </Graphics>
//     <Description>
//       This could buy you: <br /> <span>a Tesla</span>!
//     </Description>
//   </Fragment>
// );

// export default Car;
